var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.95 1.8C1.77761 1.8 1.61228 1.86848 1.49038 1.99038C1.36848 2.11228 1.3 2.27761 1.3 2.45V11.55C1.3 11.7224 1.36848 11.8877 1.49038 12.0096C1.61228 12.1315 1.77761 12.2 1.95 12.2H4.55C4.90898 12.2 5.2 12.491 5.2 12.85C5.2 13.209 4.90898 13.5 4.55 13.5H1.95C1.43283 13.5 0.936837 13.2946 0.571142 12.9289C0.205446 12.5632 0 12.0672 0 11.55V2.45C0 1.93283 0.205446 1.43684 0.571142 1.07114C0.936838 0.705446 1.43283 0.5 1.95 0.5H4.55C4.90898 0.5 5.2 0.791015 5.2 1.15C5.2 1.50899 4.90898 1.8 4.55 1.8H1.95Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64033 3.28999C8.89417 3.03615 9.30573 3.03615 9.55957 3.28999L12.8096 6.53999C13.0634 6.79383 13.0634 7.20539 12.8096 7.45923L9.55957 10.7092C9.30573 10.9631 8.89417 10.9631 8.64033 10.7092C8.38649 10.4554 8.38649 10.0438 8.64033 9.78999L11.4307 6.99961L8.64033 4.20923C8.38649 3.95539 8.38649 3.54383 8.64033 3.28999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.90002 6.99961C3.90002 6.64062 4.19104 6.34961 4.55002 6.34961H12.35C12.709 6.34961 13 6.64062 13 6.99961C13 7.35859 12.709 7.64961 12.35 7.64961H4.55002C4.19104 7.64961 3.90002 7.35859 3.90002 6.99961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.53a87565fc40ad3c063af00d8d8a8ecb.svg";
export { ForwardRef as ReactComponent };